// startup
// Load entry module and return exports
__webpack_require__("./src/scripts/main.js");
__webpack_require__("./src/styles/main/_main.css");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./components/00-icons/ui/underline/underline.svg");
__webpack_require__("./components/00-icons/ui/swipe/swipe.svg");
__webpack_require__("./components/00-icons/ui/send/send.svg");
__webpack_require__("./components/00-icons/ui/pencil/pencil.svg");
__webpack_require__("./components/00-icons/ui/eye/eye.svg");
__webpack_require__("./components/00-icons/ui/eraser/eraser.svg");
__webpack_require__("./components/00-icons/ui/close/close.svg");
__webpack_require__("./components/00-icons/ui/check/check.svg");
__webpack_require__("./components/00-icons/ui/camera/camera.svg");
__webpack_require__("./components/00-icons/brand/logo/logo--small.svg");
var __webpack_exports__ = __webpack_require__("./components/00-icons/brand/logo/logo--full.svg");
